import { InviteProfileMessages } from 'src/constants/inviteProfileMessages';
import * as Yup from 'yup';

export default Yup.object().shape(
  {
    name: Yup.string()
      .required('You must enter a name')
      .min(2, 'Name must 2 or more characters')
      .max(35, 'Name must be less than 35 characters'),
    jobTitle: Yup.string()
      .required('You must enter a job title')
      .min(2, 'Job title must 2 or more characters')
      .max(35, 'Job title must be less than 35 characters'),
    accountTypeId: Yup.string().required(
      InviteProfileMessages.accountTypeId.required,
    ),
    siteId: Yup.string().when('accountTypeId', (value, schema) => {
      if (value !== 'AT_colleague') {
        return Yup.string()
          .required(InviteProfileMessages.siteId.required)
          .max(8, `${InviteProfileMessages.siteId.max} 8`);
      } else {
        return Yup.string().notRequired();
      }
    }),
    isPartner: Yup.string().required(InviteProfileMessages.isPartner.required),
    roles: Yup.array().of(Yup.string()),
    tags: Yup.array().of(Yup.string()),
    partnerName: Yup.string().when('isPartner', {
      is: 'yes',
      then: Yup.string().required(InviteProfileMessages.partnerName.required),
    }),
    partnerContact: Yup.string().when('isPartner', {
      is: 'yes',
      then: Yup.string().required(
        InviteProfileMessages.partnerContact.required,
      ),
    }),
  },
  [
    ['isPartner', 'isPartner'],
    ['accountTypeId', 'accountTypeId'],
  ],
);
